import { UserPermissionGuard } from './user-permission-guard';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UserPermissionsStorage } from './user-permissions-storage';

@NgModule({
    imports: [
        CommonModule
    ],
    providers: [
        UserPermissionsStorage,
        UserPermissionGuard
    ],
})
export class UserPermissionsModule { }
